import { Injectable } from '@angular/core';
import { RootService } from '@app/core/root.service';
import { ItemProps } from '@app/interfaces';
import { Router } from '@angular/router';
import { ApiRequestService } from '@app/core/http/api-request.service';
import { Validators } from '@angular/forms';
import { PermissionsService } from '@app/core/permissions/permissions.service';
import { CustomValidators } from '@app/core/classes/custom-validators/custom-validators';
import { SharedService } from '@app/shared/services/shared.service';
import { ToArabicPipe } from '@app/shared/pipes/toArabic.pipe';
import { Observable } from 'rxjs';
import { UsersService } from '@app/users-feature/users.service';

@Injectable({
  providedIn: 'root'
})
export class SortingPlantService extends RootService {
  constructor(
    router: Router,
    api: ApiRequestService,
    shared: SharedService,
    permissionsService: PermissionsService,
    private toArabicPipe: ToArabicPipe,
    private usersService: UsersService
  ) {
    super(router, api, permissionsService, shared);
    this.permissionsKey = 'permission';
  }

  routerPrefix(val: string = '') {
    return val ? val : 'sorting-area-permissions';
  }

  refactorItem(item: any) {
    return item;
  }
  navigateToList() {
    this.usersService.updateResources.next(null);
    return super.navigateToList();
  }

  refactorSelectListsResponse(listPrefix: string, response: any, listPaginate: boolean = false): any {
    if (response.data) {
      if (listPaginate) {
        return response;
      } else {
        return response.data;
      }
    }
  }
  refactorFormBeforeSubmit(formValue: any) {
    formValue['units'] = [];
    let unitsObject = {
      plate_number: formValue['plate_number'],
      rfid: formValue['rfid'] ? +formValue['rfid'] : null,
      qr_code: formValue['qr_code'] ? +formValue['qr_code'] : null
    };
    formValue['units'].push(unitsObject);
    // if (formValue['units'].length > 1) {
    //   const unitsLength = formValue['units'].length;
    //   if (!formValue['units'][unitsLength - 1]['plate_number']) {
    //     formValue['units'].pop();
    //   } else formValue['units'].pop();

    //   formValue['units'].map((unit: any) => {
    //     unit['qr_code'] = unit['qr_code'] ? +unit['qr_code'] : null;
    //     unit['rfid'] = unit['rfid'] ? +unit['rfid'] : null;
    //     return unit;
    //   });
    // }
    if (formValue.permission_date_input) {
      formValue.permission_date = this.shared.dateToCustomFormat(formValue.permission_date_input, 'DD-MM-YYYY');
    }

    if (formValue.national_id) {
      formValue['national_id'] = parseInt(formValue.national_id);
    }

    if (formValue.allowed_weight) {
      formValue['allowed_weight'] = parseInt(formValue.allowed_weight);
    }
    console.log('formValue', formValue);

    return formValue;
  }

  getRequest(url: string) {
    return this.api.request('GET', url, {}, {}, {});
  }

  onChangedValue(column: ItemProps, event: any) {
    super.onChangedValue(column, event);
  }

  get featureProps(): ItemProps[] {
    return [
      //tab 1 [permission tab]
      {
        name: 'waste_type_id',
        prop: 'waste_type_id',
        form: {
          Validators: [Validators.required],
          formFieldType: 'ng_select',
          listPrefix: 'waste_types',
          dataUrl: 'waste-types',
          appendTo: '.default-form',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'sorting-area-permissions.permission_tab',
              steps: true
            }
          }
        }
      },
      {
        name: 'allowed_weight',
        prop: 'allowed_weight',
        form: {
          formFieldType: 'text_number',
          Validators: [],
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'sorting-area-permissions.permission_tab'
            }
          },
          maxLength: 10
        }
      },
      //tab 2 [company tab]
      {
        name: 'entity_name',
        prop: 'entity_name',
        form: {
          Validators: [Validators.required, Validators.minLength(3), Validators.maxLength(50)],
          formFieldType: 'text',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'sorting-area-permissions.company_tab'
            }
          },
          maxLength: 50,
          minLength: 3
        }
      },
      {
        name: 'representative_name',
        prop: 'representative_name',
        form: {
          Validators: [],
          maxLength: 50,
          minLength: 3,
          formFieldType: 'text',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'sorting-area-permissions.company_tab'
            }
          }
        }
      },
      {
        name: 'national_id',
        prop: 'national_id',
        form: {
          Validators: [Validators.pattern(/^[1-2][\d]+$/), Validators.minLength(10), Validators.maxLength(10)],
          maxLength: 10,
          minLength: 10,
          formFieldType: 'text_number',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'sorting-area-permissions.company_tab'
            }
          }
        }
      },
      //tab 3 [units tab]
      {
        name: 'plate_number',
        prop: 'plate_number',
        form: {
          Validators: [Validators.required, Validators.minLength(4), Validators.maxLength(8)],
          formFieldType: 'text',
          maxLength: 8,
          minLength: 4,
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'sorting-area-permissions.units',
              steps: true
            }
          }
        }
      },
      {
        name: 'qr_code',
        prop: 'qr_code',
        form: {
          formFieldType: 'text_number',
          Validators: [Validators.required],
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'sorting-area-permissions.units'
            }
          }
        }
      },

      {
        name: 'rfid',
        prop: 'rfid',
        form: {
          Validators: [],
          formFieldType: 'text_number',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'sorting-area-permissions.units'
            }
          }
        }
      }
    ];
  }
}
